import script from "./PrizeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PrizeIcon.vue?vue&type=script&setup=true&lang=js"

import "./PrizeIcon.vue?vue&type=style&index=0&id=5b943d91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b943d91"]])

export default __exports__